<mat-drawer-container class="dashboard">
    <mat-drawer (closed)="onDrawerClosed()" [mode]="drawerMode()" [opened]="isDrawerOpen()" class="max-w-[320px]">
        <app-site-nav (navItemClick)="onNavItemClick()"></app-site-nav>
    </mat-drawer>
    <mat-drawer-content>
        <app-navbar (toggleDrawer)="toggleDrawer()"></app-navbar>
        <div class="dashboard__content">
            <div class="dashboard__content-wrapper">
                <router-outlet></router-outlet>
            </div>
        </div>
    </mat-drawer-content>
</mat-drawer-container>
